'use strict';

/**
 * @ngdoc function
 * @name thothApp.services:ActivityTemplate
 * @description
 * # ActivityTemplate
 * Service to contact activity templates API
 */
angular.module('thothApp.services')
  .factory('ActivityTemplate', ['$http', 'domain', 'BaseService', function ($http, domain, BaseService) {
    var BASE_URL = domain.name + '/api/v1/activity_templates/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_URL,
      baseModelName: 'activity_template'
    });

    baseService.mine = function (employeeId, filters) {
      var params = angular.extend({ by_employee: employeeId }, filters || {});
      return $http.get(BASE_URL, { params: params });
    };

    // Sube la favorita en la barra de rapidas. No escribe nada en la actividad.
    baseService.markAsUsed = function (id) {
      return $http.post(BASE_URL + id + '/use');
    };

    baseService.error = function (error) {
      baseService.baseError(error);
    };

    return baseService;
  }]);
